<script>
    export let term;
    export let text;

    $: re = new RegExp(`(${escapeRegExp(term)})`, 'ig');

    $: splitText = text.split(re);

    function escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
    }
</script>

{#if term}
    {#each splitText as textPart, idx}
        {#if idx % 2 != 0}<span class="highlight">{textPart}</span>{:else}{textPart}{/if}
    {/each}
{:else}
    {text}
{/if}

<style>
    .highlight {
        background-color: yellow;
    }
</style>